<template>
    <v-container>
      <h3>Mini Games</h3>
      <v-row dense>
        <v-col
          v-for="game in games"
          :key="game.name"
          xl="3"
          lg="3"
          md="4"
          sm="4"
        >
          <v-card class="mx-auto"  elevation="6">
            <v-img :src="game.image" cover />
            <v-card-title class="py-2 mb-0">{{ game.name }}</v-card-title>
            <v-card-actions class="pt-0">
              <v-spacer></v-spacer>
              <router-link :to="game.link">
                <v-btn color="indigo" outlined>Play</v-btn>
              </router-link>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </template>
  
  <script>
  export default {
    name: "GameList",
    data() {
      return {
        games: [
          {
            name: "Color Spotting",
            link: "/mini-games/color-spotting-game",
            image: require("@/assets/games/color_spotting_poster.png"), 
          },
          // Add more games as needed
        ],
      };
    },
  };
  </script>
  
